import animateRequisitesCard from "../../scripts/animateRequisitesCard";
import initRequisitesNav from '../../scripts/initRequisitesNav'

export default {
	data() {
		return {
			languageType: 'russian',
			requisitesCardType: 'eur'
		}
	},
	mounted() {
		animateRequisitesCard();
		initRequisitesNav();
	}
}
